"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientEvent = void 0;
var irt_1 = require("@playq/irt");
var EventPlayerProfile_1 = require("./EventPlayerProfile");
var SystemClientProperties_1 = require("./SystemClientProperties");
var EventProperties_1 = require("./EventProperties");
var EventBase_1 = require("./EventBase");
var ClientEvent = (function () {
    function ClientEvent(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            this.varchars = {};
            this.doubles = {};
            this.datetimes = {};
            this.int4s = {};
            this.int8s = {};
            return;
        }
        this.deviceId = data.deviceId;
        this.deviceIdType = data.deviceIdType;
        this.timezone = data.timezone;
        this.online = data.online;
        this.appVersion = data.appVersion;
        this.deviceDays = data.deviceDays;
        this.deviceSessions = data.deviceSessions;
        this.eventID = data.eventID;
        this.eventAtAsString = data.eventAt;
        this.eventDateAsString = data.eventDate;
        this.varchars = Object.keys(data.varchars).reduce(function (previous, current) { previous[current] = data.varchars[current]; return previous; }, {});
        this.doubles = Object.keys(data.doubles).reduce(function (previous, current) { previous[current] = data.doubles[current]; return previous; }, {});
        this.datetimes = Object.keys(data.datetimes).reduce(function (previous, current) { previous[current] = data.datetimes[current]; return previous; }, {});
        this.int4s = Object.keys(data.int4s).reduce(function (previous, current) { previous[current] = data.int4s[current]; return previous; }, {});
        this.int8s = Object.keys(data.int8s).reduce(function (previous, current) { previous[current] = data.int8s[current]; return previous; }, {});
        this.player = typeof data.player !== 'undefined' ? new EventPlayerProfile_1.EventPlayerProfile(data.player) : undefined;
    }
    ClientEvent.prototype.getPackageName = function () { return ClientEvent.PackageName; };
    ClientEvent.prototype.getClassName = function () { return ClientEvent.ClassName; };
    ClientEvent.prototype.getFullClassName = function () { return ClientEvent.FullClassName; };
    Object.defineProperty(ClientEvent.prototype, "deviceId", {
        get: function () {
            return this._deviceId;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field deviceId is not optional');
            }
            if (typeof value !== 'string') {
                throw new Error('Field deviceId expects type string, got ' + value);
            }
            this._deviceId = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ClientEvent.prototype, "deviceIdType", {
        get: function () {
            return this._deviceIdType;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field deviceIdType is not optional');
            }
            if (typeof value !== 'string') {
                throw new Error('Field deviceIdType expects type string, got ' + value);
            }
            this._deviceIdType = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ClientEvent.prototype, "timezone", {
        get: function () {
            return this._timezone;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field timezone is not optional');
            }
            if (typeof value !== 'number') {
                throw new Error('Field timezone expects type number, got ' + value);
            }
            if (value % 1 !== 0) {
                throw new Error('Field timezone is expected to be an integer, got ' + value);
            }
            if (value < -32768) {
                throw new Error('Field timezone is expected to be not less than -32768, got ' + value);
            }
            if (value > 32767) {
                throw new Error('Field timezone is expected to be not greater than 32767, got ' + value);
            }
            this._timezone = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ClientEvent.prototype, "online", {
        get: function () {
            return this._online;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field online is not optional');
            }
            if (typeof value !== 'boolean') {
                throw new Error('Field online expects boolean type, got ' + value);
            }
            this._online = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ClientEvent.prototype, "appVersion", {
        get: function () {
            return this._appVersion;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field appVersion is not optional');
            }
            if (typeof value !== 'string') {
                throw new Error('Field appVersion expects type string, got ' + value);
            }
            this._appVersion = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ClientEvent.prototype, "deviceDays", {
        get: function () {
            return this._deviceDays;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field deviceDays is not optional');
            }
            if (typeof value !== 'number') {
                throw new Error('Field deviceDays expects type number, got ' + value);
            }
            if (value % 1 !== 0) {
                throw new Error('Field deviceDays is expected to be an integer, got ' + value);
            }
            this._deviceDays = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ClientEvent.prototype, "deviceSessions", {
        get: function () {
            return this._deviceSessions;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field deviceSessions is not optional');
            }
            if (typeof value !== 'number') {
                throw new Error('Field deviceSessions expects type number, got ' + value);
            }
            if (value % 1 !== 0) {
                throw new Error('Field deviceSessions is expected to be an integer, got ' + value);
            }
            this._deviceSessions = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ClientEvent.prototype, "eventID", {
        get: function () {
            return this._eventID;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field eventID is not optional');
            }
            if (typeof value !== 'number') {
                throw new Error('Field eventID expects type number, got ' + value);
            }
            if (value % 1 !== 0) {
                throw new Error('Field eventID is expected to be an integer, got ' + value);
            }
            if (value < -32768) {
                throw new Error('Field eventID is expected to be not less than -32768, got ' + value);
            }
            if (value > 32767) {
                throw new Error('Field eventID is expected to be not greater than 32767, got ' + value);
            }
            this._eventID = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ClientEvent.prototype, "eventAt", {
        get: function () {
            return this._eventAt;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field eventAt is not optional');
            }
            if (!(value instanceof Date)) {
                throw new Error('Field eventAt expects type Date, got ' + value);
            }
            this._eventAt = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ClientEvent.prototype, "eventAtAsString", {
        get: function () {
            return irt_1.Formatter.writeZoneDateTime(this._eventAt);
        },
        set: function (value) {
            if (typeof value !== 'string') {
                throw new Error('eventAtAsString expects type string, got ' + value);
            }
            this._eventAt = irt_1.Formatter.readZoneDateTime(value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ClientEvent.prototype, "eventDate", {
        get: function () {
            return this._eventDate;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field eventDate is not optional');
            }
            if (!(value instanceof Date)) {
                throw new Error('Field eventDate expects type Date, got ' + value);
            }
            this._eventDate = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ClientEvent.prototype, "eventDateAsString", {
        get: function () {
            return irt_1.Formatter.writeDate(this._eventDate);
        },
        set: function (value) {
            if (typeof value !== 'string') {
                throw new Error('eventDateAsString expects type string, got ' + value);
            }
            this._eventDate = irt_1.Formatter.readDate(value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ClientEvent.prototype, "varchars", {
        get: function () {
            return this._varchars;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field varchars is not optional');
            }
            this._varchars = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ClientEvent.prototype, "doubles", {
        get: function () {
            return this._doubles;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field doubles is not optional');
            }
            this._doubles = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ClientEvent.prototype, "datetimes", {
        get: function () {
            return this._datetimes;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field datetimes is not optional');
            }
            this._datetimes = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ClientEvent.prototype, "int4s", {
        get: function () {
            return this._int4s;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field int4s is not optional');
            }
            this._int4s = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ClientEvent.prototype, "int8s", {
        get: function () {
            return this._int8s;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field int8s is not optional');
            }
            this._int8s = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ClientEvent.prototype, "player", {
        get: function () {
            return this._player;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                this._player = undefined;
                return;
            }
            this._player = value;
        },
        enumerable: false,
        configurable: true
    });
    ClientEvent.prototype.toEventBaseSerialized = function () {
        var _this = this;
        return {
            deviceId: this.deviceId,
            deviceIdType: this.deviceIdType,
            timezone: this.timezone,
            online: this.online,
            appVersion: this.appVersion,
            deviceDays: this.deviceDays,
            deviceSessions: this.deviceSessions,
            eventID: this.eventID,
            eventAt: this.eventAtAsString,
            eventDate: this.eventDateAsString,
            varchars: Object.keys(this.varchars).reduce(function (previous, current) { previous[current] = _this.varchars[current]; return previous; }, {}),
            doubles: Object.keys(this.doubles).reduce(function (previous, current) { previous[current] = _this.doubles[current]; return previous; }, {}),
            datetimes: Object.keys(this.datetimes).reduce(function (previous, current) { previous[current] = irt_1.Formatter.writeZoneDateTime(_this.datetimes[current]); return previous; }, {}),
            int4s: Object.keys(this.int4s).reduce(function (previous, current) { previous[current] = _this.int4s[current]; return previous; }, {}),
            int8s: Object.keys(this.int8s).reduce(function (previous, current) { previous[current] = _this.int8s[current]; return previous; }, {}),
            player: typeof this.player !== 'undefined' ? this.player.serialize() : undefined
        };
    };
    ClientEvent.prototype.toEventBase = function () {
        return new EventBase_1.EventBaseStruct(this.toEventBaseSerialized());
    };
    ClientEvent.prototype.toEventPropertiesSerialized = function () {
        var _this = this;
        return {
            varchars: Object.keys(this.varchars).reduce(function (previous, current) { previous[current] = _this.varchars[current]; return previous; }, {}),
            doubles: Object.keys(this.doubles).reduce(function (previous, current) { previous[current] = _this.doubles[current]; return previous; }, {}),
            datetimes: Object.keys(this.datetimes).reduce(function (previous, current) { previous[current] = irt_1.Formatter.writeZoneDateTime(_this.datetimes[current]); return previous; }, {}),
            int4s: Object.keys(this.int4s).reduce(function (previous, current) { previous[current] = _this.int4s[current]; return previous; }, {}),
            int8s: Object.keys(this.int8s).reduce(function (previous, current) { previous[current] = _this.int8s[current]; return previous; }, {})
        };
    };
    ClientEvent.prototype.toEventProperties = function () {
        return new EventProperties_1.EventPropertiesStruct(this.toEventPropertiesSerialized());
    };
    ClientEvent.prototype.toSystemClientPropertiesSerialized = function () {
        return {
            deviceId: this.deviceId,
            deviceIdType: this.deviceIdType,
            timezone: this.timezone,
            online: this.online,
            appVersion: this.appVersion,
            deviceDays: this.deviceDays,
            deviceSessions: this.deviceSessions,
            eventID: this.eventID,
            eventAt: this.eventAtAsString,
            eventDate: this.eventDateAsString
        };
    };
    ClientEvent.prototype.toSystemClientProperties = function () {
        return new SystemClientProperties_1.SystemClientPropertiesStruct(this.toSystemClientPropertiesSerialized());
    };
    ClientEvent.prototype.loadEventBaseSerialized = function (slice) {
        this.deviceId = slice.deviceId;
        this.deviceIdType = slice.deviceIdType;
        this.timezone = slice.timezone;
        this.online = slice.online;
        this.appVersion = slice.appVersion;
        this.deviceDays = slice.deviceDays;
        this.deviceSessions = slice.deviceSessions;
        this.eventID = slice.eventID;
        this.eventAtAsString = slice.eventAt;
        this.eventDateAsString = slice.eventDate;
        this.varchars = Object.keys(slice.varchars).reduce(function (previous, current) { previous[current] = slice.varchars[current]; return previous; }, {});
        this.doubles = Object.keys(slice.doubles).reduce(function (previous, current) { previous[current] = slice.doubles[current]; return previous; }, {});
        this.datetimes = Object.keys(slice.datetimes).reduce(function (previous, current) { previous[current] = slice.datetimes[current]; return previous; }, {});
        this.int4s = Object.keys(slice.int4s).reduce(function (previous, current) { previous[current] = slice.int4s[current]; return previous; }, {});
        this.int8s = Object.keys(slice.int8s).reduce(function (previous, current) { previous[current] = slice.int8s[current]; return previous; }, {});
        this.player = typeof slice.player !== 'undefined' ? new EventPlayerProfile_1.EventPlayerProfile(slice.player) : undefined;
    };
    ClientEvent.prototype.loadEventBase = function (slice) {
        this.loadEventBaseSerialized(slice.serialize());
    };
    ClientEvent.prototype.loadEventPropertiesSerialized = function (slice) {
        this.varchars = Object.keys(slice.varchars).reduce(function (previous, current) { previous[current] = slice.varchars[current]; return previous; }, {});
        this.doubles = Object.keys(slice.doubles).reduce(function (previous, current) { previous[current] = slice.doubles[current]; return previous; }, {});
        this.datetimes = Object.keys(slice.datetimes).reduce(function (previous, current) { previous[current] = slice.datetimes[current]; return previous; }, {});
        this.int4s = Object.keys(slice.int4s).reduce(function (previous, current) { previous[current] = slice.int4s[current]; return previous; }, {});
        this.int8s = Object.keys(slice.int8s).reduce(function (previous, current) { previous[current] = slice.int8s[current]; return previous; }, {});
    };
    ClientEvent.prototype.loadEventProperties = function (slice) {
        this.loadEventPropertiesSerialized(slice.serialize());
    };
    ClientEvent.prototype.loadSystemClientPropertiesSerialized = function (slice) {
        this.deviceId = slice.deviceId;
        this.deviceIdType = slice.deviceIdType;
        this.timezone = slice.timezone;
        this.online = slice.online;
        this.appVersion = slice.appVersion;
        this.deviceDays = slice.deviceDays;
        this.deviceSessions = slice.deviceSessions;
        this.eventID = slice.eventID;
        this.eventAtAsString = slice.eventAt;
        this.eventDateAsString = slice.eventDate;
    };
    ClientEvent.prototype.loadSystemClientProperties = function (slice) {
        this.loadSystemClientPropertiesSerialized(slice.serialize());
    };
    ClientEvent.prototype.serialize = function () {
        var _this = this;
        return {
            deviceId: this.deviceId,
            deviceIdType: this.deviceIdType,
            timezone: this.timezone,
            online: this.online,
            appVersion: this.appVersion,
            deviceDays: this.deviceDays,
            deviceSessions: this.deviceSessions,
            eventID: this.eventID,
            eventAt: this.eventAtAsString,
            eventDate: this.eventDateAsString,
            varchars: Object.keys(this.varchars).reduce(function (previous, current) { previous[current] = _this.varchars[current]; return previous; }, {}),
            doubles: Object.keys(this.doubles).reduce(function (previous, current) { previous[current] = _this.doubles[current]; return previous; }, {}),
            datetimes: Object.keys(this.datetimes).reduce(function (previous, current) { previous[current] = irt_1.Formatter.writeZoneDateTime(_this.datetimes[current]); return previous; }, {}),
            int4s: Object.keys(this.int4s).reduce(function (previous, current) { previous[current] = _this.int4s[current]; return previous; }, {}),
            int8s: Object.keys(this.int8s).reduce(function (previous, current) { previous[current] = _this.int8s[current]; return previous; }, {}),
            player: typeof this.player !== 'undefined' ? this.player.serialize() : undefined
        };
    };
    ClientEvent.PackageName = 'net.playq.services.vortex';
    ClientEvent.ClassName = 'ClientEvent';
    ClientEvent.FullClassName = 'net.playq.services.vortex.ClientEvent';
    return ClientEvent;
}());
exports.ClientEvent = ClientEvent;
EventBase_1.EventBaseStruct.register(ClientEvent.FullClassName, ClientEvent);
EventProperties_1.EventPropertiesStruct.register(ClientEvent.FullClassName, ClientEvent);
SystemClientProperties_1.SystemClientPropertiesStruct.register(ClientEvent.FullClassName, ClientEvent);
var irt_2 = require("@playq/irt");
irt_2.Introspector.register(ClientEvent.FullClassName, {
    full: ClientEvent.FullClassName,
    short: ClientEvent.ClassName,
    package: ClientEvent.PackageName,
    type: irt_2.IntrospectorTypes.Data,
    ctor: function () { return new ClientEvent(); },
    fields: [
        {
            name: 'deviceId',
            accessName: 'deviceId',
            type: { intro: irt_2.IntrospectorTypes.Str }
        },
        {
            name: 'deviceIdType',
            accessName: 'deviceIdType',
            type: { intro: irt_2.IntrospectorTypes.Str }
        },
        {
            name: 'timezone',
            accessName: 'timezone',
            type: { intro: irt_2.IntrospectorTypes.I16 }
        },
        {
            name: 'online',
            accessName: 'online',
            type: { intro: irt_2.IntrospectorTypes.Bool }
        },
        {
            name: 'appVersion',
            accessName: 'appVersion',
            type: { intro: irt_2.IntrospectorTypes.Str }
        },
        {
            name: 'deviceDays',
            accessName: 'deviceDays',
            type: { intro: irt_2.IntrospectorTypes.I32 }
        },
        {
            name: 'deviceSessions',
            accessName: 'deviceSessions',
            type: { intro: irt_2.IntrospectorTypes.I32 }
        },
        {
            name: 'eventID',
            accessName: 'eventID',
            type: { intro: irt_2.IntrospectorTypes.I16 }
        },
        {
            name: 'eventAt',
            accessName: 'eventAt',
            type: { intro: irt_2.IntrospectorTypes.Tsz }
        },
        {
            name: 'eventDate',
            accessName: 'eventDate',
            type: { intro: irt_2.IntrospectorTypes.Date }
        },
        {
            name: 'varchars',
            accessName: 'varchars',
            type: { intro: irt_2.IntrospectorTypes.Map, key: { intro: irt_2.IntrospectorTypes.Str }, value: { intro: irt_2.IntrospectorTypes.Str } }
        },
        {
            name: 'doubles',
            accessName: 'doubles',
            type: { intro: irt_2.IntrospectorTypes.Map, key: { intro: irt_2.IntrospectorTypes.Str }, value: { intro: irt_2.IntrospectorTypes.F64 } }
        },
        {
            name: 'datetimes',
            accessName: 'datetimes',
            type: { intro: irt_2.IntrospectorTypes.Map, key: { intro: irt_2.IntrospectorTypes.Str }, value: { intro: irt_2.IntrospectorTypes.Tsz } }
        },
        {
            name: 'int4s',
            accessName: 'int4s',
            type: { intro: irt_2.IntrospectorTypes.Map, key: { intro: irt_2.IntrospectorTypes.Str }, value: { intro: irt_2.IntrospectorTypes.I32 } }
        },
        {
            name: 'int8s',
            accessName: 'int8s',
            type: { intro: irt_2.IntrospectorTypes.Map, key: { intro: irt_2.IntrospectorTypes.Str }, value: { intro: irt_2.IntrospectorTypes.I64 } }
        },
        {
            name: 'player',
            accessName: 'player',
            type: { intro: irt_2.IntrospectorTypes.Opt, value: { intro: irt_2.IntrospectorTypes.Data, full: 'net.playq.services.vortex.EventPlayerProfile' } }
        }
    ]
});
//# sourceMappingURL=ClientEvent.js.map